import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ open: boolean }>`
  transition: 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28) 0s;
  width: 20rem;
  margin-right: ${({ open }) => (open ? '0rem' : '-20rem')};
`;

export const Container = styled.div`
  ${({ theme: { spacing, border, color } }) => css`
    display: grid;
    grid-auto-rows: max-content;
    grid-gap: ${spacing.km8};
    padding: ${spacing.km10} ${spacing.km6};
    margin-top: calc(${spacing.km10} * 2);
    width: 20rem;
    height: calc(100% - (${spacing.km10} * 2));
    border-left: ${border.width.thinner} ${border.style.solid} ${color.border.neutral.default};
  `}
`;
